import React from 'react'

function Footer() {
  return (
    <>
    <footer className='footer-bg p-5'>
        <div className='container text-left text-light'>
            <div className='row'>
                <div className='col-lg-5'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <h5 className='py-2 border-1'><strong> ABOUT US</strong>  </h5>
                                <a><h6>About Smile</h6></a>
                                <a><h6>Impact</h6></a>
                                <a><h6>Reach & Presence</h6></a>
                                <a><h6>Smilestones</h6></a>
                            </div>
                            <div className='col-lg-6'>
                                <h5 className='py-2 border-1'><strong> OUR WORK</strong></h5>
                                <a><h6>Education</h6></a>
                                <a><h6>Health</h6> </a>   
                                <a><h6>Livelihood</h6></a>
                                <a><h6>Women Empowerment</h6></a>
                                <a><h6>Disaster Response</h6></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-lg-7'>
                <div className='container'>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <h5 className='py-2 border-1'><strong> CAMPAIGNS</strong> </h5>
                                <a><h6>Tayyari Kal Ki</h6></a>
                                <a><h6>Shiksha Na Ruke</h6></a>    
                                <a><h6>Health Cannot Wait</h6></a>
                                <a><h6>She Can Fly</h6></a>
                            </div>
                            
                            <div className='col-lg-4'>
                                <h5 className='py-2 border-1'><strong>GET INVOLVED</strong> </h5>
                                <a><h6>Individual Support</h6></a>
                                <a><h6>Corporate Partnerships</h6> </a>  
                                <a><h6>Volunteer</h6></a>
                                <a><h6>School Partnerships</h6></a>
                                <a><h6>Careers</h6></a>
                            </div>
                            
                            <div className='col-lg-4'>
                                <h5 className='py-2 border-1'><strong>RESOURCE CENTRE</strong> </h5>
                                <a><h6>Annual Report</h6></a>
                                <a><h6>Newsletter</h6> </a>   
                                <a><h6>Stories of Change</h6></a>
                                <a><h6>The Smile Blog</h6></a>
                                <a><h6>Films</h6></a>
                            </div>
                        </div>
                     </div>            
                </div>

                <div className='container py-5'>
                    <div className='row py-5'>
                        <div className='col-lg-1 '></div>
                        <div className='col-lg-10 border-1 '></div>
                        <div className='col-lg-1'></div>
                    </div>
                </div>

                
                <p className='para-1 py-3'>Smile Foundation
                <br/>161 B/4, 3rd Floor, Gulmohar House, Yusuf Sarai Community Centre 
                <br/>New Delhi - 110049 Delhi, India</p>

                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-8'><p className='para-1 py-3'>Contact Us: Tel: +91-11-43123700 | E-mail: info@smilefoundationindia.org</p></div>
                        <div className='col-lg-4 '>
                        <a href='https://www.facebook.com/smilefoundationindia.org'><i class="bi bi-facebook  px-2  icon-2 " ></i></a>
                        <a href='https://twitter.com/smilefoundation'><i class="bi bi-twitter px-2 icon-2 "></i></a>
                        <a href='https://www.youtube.com/user/tubeforchange'><i class="bi bi-youtube px-2 icon-2 "></i></a>
                        <a href='https://www.instagram.com/smilefoundationindia/'><i class="bi bi-instagram px-2 icon-2 "></i></a>
                        <a href='https://www.linkedin.com/company/smile-foundation'><i class="bi bi-linkedin px-2 icon-2 "></i></a>
                        </div>
                    </div>
                </div>
                


                <p className='para-1 py-3 my-4'>Subscribe to Our Newsletter</p>
                <form>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-4'><input type="text" class=" mx-2 py-2 w-50 in-2" placeholder="Name"/></div>
                            <div className='col-lg-6 '><input type="email" class="  mx-2 py-2 in-2 w-75 " placeholder="Enter Your Email"/></div>
                            <div className='col-lg-2'><button type="submit" class="btn btn-1 mb-3 ">Subscribe</button></div>
                        </div>
                    </div>
                    
                    
                    

                </form>
            </div>
        </div>
    </footer>
    </>
  )
}

export default Footer